/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/order */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import { PropsWithChildren, useEffect, useState } from "react";
import api from "../services/api";
import { useTheme } from "@mui/material";
import { TailSpin } from "react-loader-spinner";
import { useSearchParams } from "react-router-dom";
import UnauthorizedPage from "../pages/UnauthorizedPage";
import useCustomSnackBar from "../hooks/useCustomSnackBar";
import { IRegisterValidationResponse } from "../types/forms";

interface IHashValidationWrapperProps {
  onValidateHash: (response: IRegisterValidationResponse) => any;
}

export default function HashValidationWrapper({
  children,
  onValidateHash
}: PropsWithChildren<IHashValidationWrapperProps>) {
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const { toastMessage } = useCustomSnackBar();

  useEffect(() => {
    const hash = searchParams.get("hash") as string;

    api
      .getValidateRegisterHash(hash)
      .then(v => {
        if (!v.data.success) {
          setError(true);
          toastMessage(v.data.message);
        } else {
          onValidateHash(v.data.data);
        }
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <>
      {!loading ? (
        !error ? (
          children || <div />
        ) : (
          <UnauthorizedPage />
        )
      ) : (
        <div className="w-full h-screen flex justify-center items-center">
          <TailSpin color={theme.palette.primary.main} radius={16} />
        </div>
      )}
    </>
  );
}
